import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider, PAGE_SIZES) {
    var states = [
        {
            name: 'importHistory',
            parent: 'analysis',
            url: '/import-history?page&size&sort&from&to&status&importType',
            data: {
                viewAuthorities: ['ORGANIZATIONS_WRITE'],
                editAuthorities: ['ORGANIZATIONS_WRITE', 'ANALYSIS_PARTIAL_WRITE', 'MECHANISTICANALYSISDATAS_IMPORTAR']
            },
            component: 'importHistoryPage',
            params: {
                size: {
                    value: PAGE_SIZES[0],
                    type: 'int',
                    squash: true,
                    dynamic: true
                },
                page: {
                    value: 0,
                    type: 'int',
                    squash: true,
                    dynamic: true
                },
                sort: {
                    value: 'startDate,desc',
                    squash: true,
                    dynamic: true
                },
                from: {
                    value: null,
                    squash: true,
                    dynamic: true
                },
                to: {
                    value: null,
                    squash: true,
                    dynamic: true
                },
                status: {
                    value: null,
                    squash: true,
                    dynamic: true
                },
                importType: {
                    value: null,
                    squash: true,
                    dynamic: true
                }
            }
        }
    ];

    states.forEach(state => $stateProvider.state(state));
}

app.config(stateConfig);
